import React from "react";
import assets from "../../../shared/constants/assetVariables";

const steps = [
  {
    id: 1,
    heading: "User Onboarding & Initial Setup",
    description: "Define organizational structure, material topics, and stakeholder groups.",
    icon: assets.icons.stepsIcon1,
  },
  {
    id: 2,
    heading: "Double Materiality Assessment",
    description: "Conduct AI-driven impact & financial risk evaluations for sustainability topics.",
    icon: assets.icons.stepsIcon2,
  },
  {
    id: 3,
    heading: "ESG Data Collection",
    description:
      "Track, validate, and reuse existing ESG data for reporting, minimizing data entry effort.",
    icon: assets.icons.stepsIcon3,
  },
  {
    id: 4,
    heading: "Report Generation",
    description: "Structure disclosures into narrative & XBRL-tagged formats.",
    icon: assets.icons.stepsIcon4,
  },
  {
    id: 5,
    heading: "Validation & Compliance Tracking",
    description: "Ensure completeness, flag missing disclosures, and monitor audit readiness.",
    icon: assets.icons.stepsIcon5,
  },
  {
    id: 6,
    heading: "Final Reporting & Submission",
    description:
      "Generate final reports in PDF, XBRL, or export formats for internal & regulatory use.",
    icon: assets.icons.stepsIcon6,
  },
];

function Section_8() {
  return (
    <section className="csrd-landing-page-section-8-container">
      <div className="csrd-landing-page-section-8-content-container">
        <div
          className="csrd-landing-page-section-8-content-heading"
          data-aos="zoom-in"
          data-aos-delay="100"
          data-aos-duration="700"
          data-aos-once="true">
          HOW IT WORKS
        </div>
        <div
          className="csrd-landing-page-section-8-steps-container"
          data-aos="slide-left"
          data-aos-delay="100"
          data-aos-duration="1500"
          data-aos-once="true">
          {steps?.map((step) => (
            <>
              <div className="csrd-landing-page-section-8-step-card">
                <div className="steps-icon-container">
                  <img src={step.icon} alt="step-icon" className="steps-icon" />
                </div>
                <div className={`steps_heading steps_heading${step.id}`}>{step.heading}</div>
                <div className="steps_description">{step.description}</div>
              </div>
              {step.id !== 6 && (
                <div className="step-arrow-container">
                  <div className={`step-arrow step-arrow${step.id}`}></div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Section_8;
